import { render, staticRenderFns } from "./SubMenuSteps.vue?vue&type=template&id=55d60f22&scoped=true&"
import script from "./SubMenuSteps.vue?vue&type=script&lang=js&"
export * from "./SubMenuSteps.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuSteps.vue?vue&type=style&index=0&id=55d60f22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d60f22",
  null
  
)

export default component.exports